'use client';

var classes = {
  "table": "m_b23fa0ef",
  "th": "m_4e7aa4f3",
  "tr": "m_4e7aa4fd",
  "td": "m_4e7aa4ef",
  "tbody": "m_b2404537",
  "thead": "m_b242d975",
  "caption": "m_9e5a3ac7",
  "scrollContainer": "m_a100c15",
  "scrollContainerInner": "m_62259741"
};
export { classes as default };